import React from 'react';
import { Card, CardTitle } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import UnitsSoldCustomer from './UnitsSoldCustomer';



const CustomerUnitsSold = (props) => {

  const { customerId } = useParams();
  return (
    <Card className="CustomerInsights" header="Customer Insights">
      <CardTitle>Customer Insights</CardTitle>
      <div><UnitsSoldCustomer contactName={customerId} /></div>
      <div><Link to={'/customer/' + customerId}>Customer Sales</Link></div>
      <div><Link to={'/customermargin/' + customerId}>Customer Margin</Link></div>
      <div><Link to={'/productbreakdown/' + customerId}>See YoY Product Breakdown</Link></div>
    </Card>
  )
}
export default CustomerUnitsSold;
